type Metadata = Record<string, unknown>;
const record = (value: unknown): Metadata => value !== null && typeof value === "object" && !Array.isArray(value) ? value as Metadata : {};
const active = (value: unknown, now: number): boolean => {
  const lease = record(value);
  if (typeof lease.run_id !== "string" || !lease.run_id) return false;
  const deadline = typeof lease.lease_until === "string" ? Date.parse(lease.lease_until) : NaN;
  return !Number.isFinite(deadline) || deadline > now;
};
export function assertHealthSyncAvailable(metadata: unknown, now = Date.now(), reason = "sync_in_progress"): void {
  const current = record(metadata);
  if (active(current.history_sync, now) || active(current.recent_sync, now)) throw new Error(reason);
}
export function claimRecentHealthMetadata(metadata: unknown, runId: string, now = Date.now()): Metadata {
  assertHealthSyncAvailable(metadata, now);
  const current = structuredClone(record(metadata));
  const history = record(current.history_sync);
  if (typeof history.run_id === "string" && history.run_id) {
    current.history_sync = { ...history, run_id: null, lease_until: null };
  }
  return { ...current, recent_sync: { version: 1, run_id: runId, lease_until: new Date(now + 120_000).toISOString() } };
}
export function releaseRecentHealthMetadata(metadata: unknown, runId: string): Metadata {
  const current = record(metadata), lease = record(current.recent_sync);
  if (lease.run_id !== runId) throw new Error("health_recent_generation_changed");
  return { ...current, recent_sync: { ...lease, run_id: null, lease_until: null } };
}
